import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filter.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5 bg-#f9f9fb" }
const _hoisted_2 = { class: "headerDiv mb-2" }
const _hoisted_3 = { class: "row w-full flex justify-between" }
const _hoisted_4 = { class: "flex gap-3" }
const _hoisted_5 = { class: "bg-white tableCornerRadius" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "w-36" }
const _hoisted_13 = { class: "searchRow" }
const _hoisted_14 = { class: "searchRow" }
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "nonEmptyTable"
}
const _hoisted_19 = ["value", "disabled"]
const _hoisted_20 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_21 = { class: "text-xs" }
const _hoisted_22 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_23 = { class: "text-xs" }
const _hoisted_24 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"]),
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "pt-2" }, "Information Classification", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(_ctx.areArraysIdsEqual ? 'btndisabled pointer-events-none' : 'btnprimary'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mapInformations && _ctx.mapInformations(...args)))
          }, "Apply", 2),
          _createElementVNode("button", {
            class: "filterButton flex",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, _cache[11] || (_cache[11] = [
            _createElementVNode("img", {
              src: _imports_0,
              class: "filterIcon"
            }, null, -1),
            _createTextVNode(" Filters ")
          ]))
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a filie folder, where we keep important documents, you'll need to arrange your data in the most logical and orderly fashion, so you and anyone else who accesses it can easily find what they're looking for. Data organization is the practice of categorizing and classifying data to make mone usable. Similar to a file folder, where we keep important documents, you'll need to arrange your data in the most logical and orderly fashion. ", -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _cache[21] || (_cache[21] = _createElementVNode("th", { class: "header cursor-pointer w-8" }, null, -1)),
            _createElementVNode("th", {
              class: "header cursor-pointer w-36",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sort('informationCategory')))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("div", null, "Information Category", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'informationCategory' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ])
            ]),
            _createElementVNode("th", {
              class: "header cursor-pointer w-36",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sort('information')))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[15] || (_cache[15] = _createElementVNode("div", null, "Information", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'information' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ])
            ]),
            _createElementVNode("th", {
              class: "header cursor-pointer w-36",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort('securityCategory')))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _cache[16] || (_cache[16] = _createElementVNode("div", null, "Security Category", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'securityCategory' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ])
            ]),
            _createElementVNode("th", {
              class: "header cursor-pointer w-36",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sort('classification')))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, "Classification", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["sort cursor-pointer", _ctx.className == 'classification' ? _ctx.classSort : 'opacity-50'])
                }, null, 2)
              ])
            ]),
            (_ctx.showFilters)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                  _cache[20] || (_cache[20] = _createElementVNode("td", null, null, -1)),
                  _createElementVNode("td", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "inputboxStylingForFilter filter-font-size",
                      placeholder: "Search",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterDummy.informationCategory) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.filterDummy.informationCategory]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "inputboxStylingForFilter filter-font-size",
                      placeholder: "Search",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterDummy.information) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.filterDummy.information]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _withDirectives(_createElementVNode("select", {
                      class: "inputboxstyling resize",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterDummy.securityCategory) = $event))
                    }, [
                      _cache[18] || (_cache[18] = _createElementVNode("option", {
                        value: "",
                        selectedInformationIds: "",
                        disabled: "",
                        hidden: ""
                      }, "Select", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSecurityCategory, (pair) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: pair,
                          value: pair.value
                        }, _toDisplayString(pair.key), 9, _hoisted_15))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filterDummy.securityCategory]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "inputboxstyling resize",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterDummy.classification) = $event))
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("option", {
                        value: "",
                        selectedInformationIds: "",
                        disabled: "",
                        hidden: ""
                      }, "Select", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbInformationClassification, (pair) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: pair,
                          value: pair.value
                        }, _toDisplayString(pair.key), 9, _hoisted_16))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.filterDummy.classification]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.sortedData.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, _cache[22] || (_cache[22] = [
                _createElementVNode("tr", { class: "cursor-pointer rowHeight" }, [
                  _createElementVNode("td", { colspan: 4 }, [
                    _createElementVNode("div", { class: "flex justify-center" }, [
                      _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                    ])
                  ])
                ], -1)
              ])))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (obj) => {
                  return (_openBlock(), _createElementBlock("tr", { key: obj }, [
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedInformationIds) = $event)),
                        value: obj._id,
                        disabled: _ctx.dummySelectedIds.includes(obj._id),
                        class: "checkbox cursor-pointer ml-4"
                      }, null, 8, _hoisted_19), [
                        [_vModelCheckbox, _ctx.selectedInformationIds]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(obj.informationCategory), 1),
                    _createElementVNode("td", null, _toDisplayString(obj.information), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-center relative rounded w-28 px-2.5 h-5 regular", _ctx.colorPriorityText(obj.securityCategory)])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full h-full absolute opacity-10 rounded", _ctx.colorPriorityBg(obj.securityCategory)])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.dbSecurityCategory.find((l) => {
                                                    return l.value == obj.securityCategory;
                                                }).key), 1)
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-center relative rounded w-28 px-2.5 h-5 regular", _ctx.colorPriorityText(obj.classification)])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-full h-full absolute opacity-10 rounded", _ctx.colorPriorityBg(obj.classification)])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getClassificationLabel(obj.classification)), 1)
                        ])
                      ], 2)
                    ])
                  ]))
                }), 128))
              ]))
        ])
      ]),
      (_ctx.sortedData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_pagination, {
              dynamicPagination: _ctx.dynamicPagination,
              onCurrentPageUpdate: _ctx.paginationUpdations,
              sortedData: _ctx.sortedData
            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}